import { render, staticRenderFns } from "./wxwl-xm-other.vue?vue&type=template&id=75a713f2&scoped=true"
import script from "./wxwl-xm-other.vue?vue&type=script&lang=js"
export * from "./wxwl-xm-other.vue?vue&type=script&lang=js"
import style0 from "./wxwl-xm-other.vue?vue&type=style&index=0&id=75a713f2&prod&lang=css"
import style1 from "./wxwl-xm-other.vue?vue&type=style&index=1&id=75a713f2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a713f2",
  null
  
)

export default component.exports